import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';

@Component({
    selector: 'app-personal',
    imports: [RouterLink],
    templateUrl: './personal.component.html'
})
export class PersonalComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  ngOnInit(): void { this.pageTitle.set('fa s-icon-contract', 'パーソナルログ'); }
}
